
const HeroSection = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-no-repeat bg-top sm:bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/c712354dc817d7365377fa6091641241.jpeg)',
          backgroundSize: 'cover'
        }}
      >
        {/* Subtle overlay for better text readability at bottom */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center w-full pt-20 sm:pt-24">
        <div className="flex flex-col items-center justify-center gap-4 sm:gap-5">
          
          {/* Logo */}
          <div className="flex justify-center">
            <img
              src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/b0c117e2f6c42a144df7e96a05b7c5b3.png"
              alt="Marche Detailing Logo"
              className="w-72 sm:w-96 md:w-[38rem] h-auto object-contain"
              style={{ filter: 'drop-shadow(0 0 30px rgba(100, 200, 255, 0.6))' }}
            />
          </div>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 font-inter max-w-3xl mx-auto px-2" style={{ textShadow: '0 0 20px rgba(100, 200, 255, 0.4)' }}>
            Luxury Detailing Experience
          </p>

          <div className="flex flex-col items-center justify-center gap-3 sm:gap-4 mt-2 sm:mt-3">
            <button
              onClick={() => scrollToSection('contact')}
              className="group relative w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-cyan-400 to-teal-400 text-black font-inter font-bold text-base sm:text-lg rounded-xl transition-all duration-500 hover:scale-105 whitespace-nowrap cursor-pointer overflow-hidden"
              style={{ boxShadow: '0 0 40px rgba(100, 200, 255, 0.6), inset 0 0 20px rgba(255, 255, 255, 0.2)' }}
            >
              <span className="relative z-10">SCHEDULE NOW</span>
              <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="group relative w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-transparent border-2 border-cyan-400 text-cyan-400 font-inter font-bold text-base sm:text-lg rounded-xl transition-all duration-500 hover:text-black whitespace-nowrap cursor-pointer overflow-hidden"
              style={{ boxShadow: '0 0 30px rgba(100, 200, 255, 0.4)' }}
            >
              <span className="relative z-10">VIEW SERVICES</span>
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-teal-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>

          {/* Discover Excellence */}
          <div className="flex flex-col items-center gap-1 mt-4 cursor-pointer animate-bounce" onClick={() => scrollToSection('process')}>
            <span className="text-cyan-400 font-inter text-xs tracking-wider font-semibold" style={{ textShadow: '0 0 15px rgba(100, 200, 255, 0.8)' }}>
              Discover Excellence
            </span>
            <div className="w-7 h-7 flex items-center justify-center rounded-full border border-cyan-400" style={{ boxShadow: '0 0 15px rgba(100, 200, 255, 0.5)' }}>
              <i className="ri-arrow-down-line text-lg text-cyan-400"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
